<style scoped>
#app {
  width: 100%;
  height: 100vh;
  /* background-image: url("../assets/login-bg.png"); */
  /* background-size: cover; */
}
.logo {
  width: 100%;
}
.logo2 {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.logo_image {
  width: 175px;
  height: 54px;
  margin: 47px 0px 0px 53px;
}
.logo_image2 {
  width: 100px;
  height: 100px;
}
.logo-form {
  width: 408px;
  height: 800px;
  /* background-color: red; */
  margin: 0 auto;
  text-align: center;
}
.logo-form-title {
  font-family: PingFang SC;
  font-size: 24px;
  font-weight: 500;
  line-height: 45px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #3d3d3d;
  margin: 16px 0px 24px 0px;
}
::v-deep .el-input__inner {
  height: 54px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #dfdfdf;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding-left: 40px;
}
::v-deep .el-input__inner::placeholder {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding-left: 16px;
}
.person_logo {
  width: 24px;
  height: 24px;
  margin: 16px 16px 0px 8px;
}
.verification_img {
  width: 127px;
  height: 46px;
  margin-top: 4px;
}
.df1 {
  display: flex;
  justify-content: end;
}
.mt16 {
  margin-top: 16px;
}
::v-deep .el-button {
  width: 100%;
  border-radius: 35px;
  background: #2e7516;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #ffffff;
  margin-top: 18px;
}

.read {
  text-align: center;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding: 16px 0px 34px 0px;
}
::v-deep .el-checkbox__inner {
  border-radius: 50%;
  margin: 0px 8px;
}
.login-line {
  display: flex;
}
.line1 {
  width: 161px;
  height: 0px;
  border-top: 1px solid #d8d8d8;
}
.line2 {
  flex: 1;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  margin-top: -8px;
}
.dialog-footer-button {
  width: 76px;
  height: 32px;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.85);
  background: #ffffff;
  line-height: 5px;
  font-size: 14px;
}
.dialog-footer-button2 {
  width: 76px;
  height: 32px;
  border-radius: 2px;
  color: #ffffff;
  background: #2e7516;
  line-height: 5px;
  font-size: 14px;
}

.header h1 {
  width: 100%;
  text-align: center;
  font-size: 24px;
}
.content {
  padding: 0px 20px 20px 20px;
}
.pt8 {
  padding-top: 8px;
}

.fw700 {
  font-weight: 700;
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #0888ff;
  margin-top: 8px;
}
ul {
  margin-left: 40px;
}
.p16 {
    padding: 16px 0px;
}
</style>
<template>
  <div class="app">
    <div class="header">
      <h1>XRION User Agreement</h1>
    </div>
    <div class="content">
      <p class="pt8 fw700">Release Date: August 1, 2025</p>
      <p class="pt8 fw700">Effective Date: August 1, 2025</p>

      <div class="fw700 pt8">
        <div class="p16">Welcome to XRION!</div>
        <div>
          Before using the text translation, voice translation, document translation, and other services provided by XRION (hereinafter referred to as "the Service"), please carefully read and fully understand this User Agreement (hereinafter referred to as "the Agreement"). By accessing or using the Service, you acknowledge that you have read, understood, and agreed to be bound by all terms of this Agreement. If you do not agree to any provision of this Agreement, please discontinue use of the Service immediately.
        </div>
      </div>

      <div class="section-title">1. Service Description</div>
      <p>1.1 Scope of XRION Services</p>
      <p>XRION provides users with the following core functionalities:</p>
      <ul>
        <li>Text Translation: Supports real-time translation across 100+ languages;</li>
        <li>Voice Translation: Enables real-time voice translation via microphone or audio file input;</li>
        <li>
          Document Translation: Supports full-text translation of PDF, DOCX, PPT, and other file formats while preserving original formatting.
        </li>
      </ul>
      <p>1.2 Service Limitations</p>
      <ul>
        <li>
          You acknowledge and agree that XRION's translation results are generated by AI technology and may contain inaccuracies, with no guarantee of 100% accuracy;
        </li>
        <li>The Service is not suitable for high-precision translation needs in specialized fields such as legal or medical domains;</li>
        <li>
          Any illegal, infringing, or system-disruptive activities (e.g., malicious scraping, automated abuse) are strictly prohibited.
        </li>
      </ul>

      <div class="section-title">2. User Account</div>
      <p>2.1 Registration and Login</p>
      <ul>
        <li>You may register an XRION account using a mobile number or email address;</li>
        <li>You must ensure the accuracy of your registration information and are responsible for safeguarding your account password and verification codes.</li>
      </ul>
      <p>2.2 Account Security</p>
      <ul>
        <li>If unauthorized access or suspicious activity is detected, please contact Customer Support immediately (admin@xrion.ai);</li>
        <li> XRION is not liable for losses resulting from user negligence (e.g., password leakage).</li>
      </ul>

      <div class="section-title">3. Usage Guidelines</div>
      <p>3.1 Prohibited Conduct</p>
      <p>You agree not to use the XRION Service for the following activities:</p>
      <ul>
        <li>Uploading or disseminating illegal, infringing, obscene, or violent content;</li>
        <li>Unauthorized bulk API calls or automated data extraction (e.g., web scraping);</li>
        <li>Disrupting Service operations (e.g., DDoS attacks, malicious traffic flooding).</li>
      </ul>
      <p>3.2 Content Responsibility</p>
      <ul>
        <li>You are solely responsible for uploaded content (text, voice, or documents) and must ensure it does not infringe third-party rights;</li>
        <li>XRION reserves the right to remove violating content and suspend or terminate access for violators.</li>
      </ul>

      <div class="section-title">4. Intellectual Property</div>
      <p>4.1 XRION's Rights</p>
      <ul>
        <li>All software, algorithms, interface designs, and related intellectual property of the Service are owned by XRION;</li>
        <li>You are granted a limited, non-exclusive license to use the Service and may not reverse-engineer or commercially resell it.</li>
      </ul>
      <p>4.2 User Content Rights</p>
      <ul>
        <li>You retain copyright ownership of original content and translation results you submit;</li>
        <li> You authorize XRION to use anonymized and de-identified data to optimize translation models.</li>
      </ul>

      <div class="section-title">5. Disclaimer</div>
      <p>5.1 Service Availability</p>
      <p>XRION strives to maintain service stability but is not liable for:</p>
      <ul>
        <li>Service interruptions caused by force majeure events (e.g., natural disasters, cyberattacks);</li>
        <li>Failures attributable to third-party services (e.g., payment or login interfaces).</li>
      </ul>
      <p>5.2 Translation Accuracy</p>
      <ul>
        <li>Translations are for reference only. XRION does not guarantee absolute accuracy and is not liable for direct/indirect losses resulting from reliance on translated content.</li>
      </ul>

      <div class="section-title">6. Agreement Modifications and Termination</div>
      <p>6.1 Updates to the Agreement</p>
      <p>XRION may revise this Agreement based on business or legal requirements. Continued use of the Service constitutes acceptance of revised terms.</p>
      <p>6.2 Account Deletion</p>
      <p>You may request account deletion via [Settings > Account Management > Delete Account]. XRION will delete your personal data within 15 business days (unless legally required to retain it).</p>
      
      <div class="section-title">7. Governing Law and Dispute Resolution</div>
      <p>7.1 This Agreement is governed by the laws of the People's Republic of China.</p>
      <p>7.2 Disputes shall first be resolved through amicable negotiation. If unresolved, disputes shall be submitted to the competent court in XRION's jurisdiction.</p>

      <p>Customer Support Email: <a href="">admin@xrion.ai </a></p>
      <p class="fw700 p16">Reminder: By using the XRION Service, you confirm that you have read, understood, and agreed to all terms of this Agreement.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserAgreementEn",
  data() {
    return {
      dialogVisible: true,
    };
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {},
};
</script>
